// extracted by mini-css-extract-plugin
module.exports = {"synchronousReader":"SynchronousReader_synchronousReader__2LMUv"};